import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AsistenteVentanaComponent } from './asistente-ventana.component';
import { AsistenciaChatModule } from '../asistencia-chat/asistencia-chat.module';
import { AsistenciaMailModule } from '../asistencia-mail/asistencia-mail.module';
import { AsistenciaMenuArbolModule } from '../asistencia-menu-arbol/asistencia-menu-arbol.module';
import { BasecomponentsModule } from '../../basecomponents/basecomponents.module';
import { AsistenciaTramiteModule } from '../asistencia-tramite/asistencia-tramite.module';

@NgModule({
  imports: [
    CommonModule,
    AsistenciaChatModule,
    AsistenciaMailModule,
    AsistenciaTramiteModule,
    AsistenciaMenuArbolModule,
    BasecomponentsModule
  ],
  declarations: [
    AsistenteVentanaComponent
  ],
  exports: [
    AsistenteVentanaComponent
  ],
  bootstrap: [
    AsistenteVentanaComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class AsistenteVentanaModule { }
